import { defineMessages } from "react-intl";

export const messages = defineMessages({
    activateRec: {
        id: "recModule.contextMenu.activateRec",
        defaultMessage: "Activate Rec",
    },
    agvanceBlendTicket: {
        id: "recModule.contextMenu.agvanceBlendTicket",
        defaultMessage: "Agvance Blend Ticket",
    },
    agvanceProducts: {
        id: "recModule.contextMenu.agvanceProducts",
        defaultMessage: "Agvance Products",
    },
    agvancePlan: {
        id: "recModule.contextMenu.agvancePlan",
        defaultMessage: "Agvance Plan",
    },
    agvanceCrop: {
        id: "recModule.contextMenu.agvanceCrop",
        defaultMessage: "Agvance Crop",
    },
    agvanceCropChemistry: {
        id: "recModule.contextMenu.agvanceCropChemistry",
        defaultMessage: "Agvance Crop Chemistry",
    },
    mixId: {
        id: "recModule.contextMenu.mixId",
        defaultMessage: "Mix ID",
    },
    bldUnit: {
        id: "recModule.contextMenu.bldUnit",
        defaultMessage: "Bld Unit",
    },
    deptId: {
        id: "recModule.contextMenu.deptId",
        defaultMessage: "Dept ID",
    },
    invUnit: {
        id: "recModule.contextMenu.invUnit",
        defaultMessage: "Inv Unit",
    },
    pkgUnit: {
        id: "recModule.contextMenu.pkgUnit",
        defaultMessage: "Pkg Unit",
    },
    sendRecToAgvanceBlendTicketTitle: {
        id: "recModule.contextMenu.sendRecToAgvanceBlendTicketTitle",
        defaultMessage: "Send Rec To Agvance Blend Ticket",
    },
    sendRecToAgvancePlanTitle: {
        id: "recModule.contextMenu.sendRecToAgvancePlanTitle",
        defaultMessage: "Send Rec To Agvance Plan",
    },
    invalidProductsTitle: {
        id: "recModule.contextMenu.invalidProductsTitle",
        defaultMessage: "Invalid Products for Agvance",
    },
    invalidProductsForAgvance: {
        id: "recModule.contextMenu.invalidProductsForAgvance",
        defaultMessage:
            "One or more Products matched in the selected Rec are not valid for sending to Agvance. Update Products in Agvance and try again.",
    },
    clear: {
        id: "recModule.contextMenu.clear",
        defaultMessage: "Clear",
    },
    confirmationText: {
        id: "recModule.varietyHybridConfirmation.confirmationText",
        defaultMessage:
            "You have 1 or more zones without a variety selected, are you sure you want to Save?",
    },
    confirmationTitle: {
        id: "recModule.varietyHybridConfirmation.confirmationTitle",
        defaultMessage: "Confirm Save",
    },
    convertRecToEvent: {
        id: "recModule.contextMenu.convertRecToEvent",
        defaultMessage: "Convert To Event",
    },
    copy: {
        id: "recModule.contextMenu.copy",
        defaultMessage: "Copy",
    },
    delete: {
        id: "recModule.contextMenu.delete",
        defaultMessage: "Delete",
    },
    deleteRecConfirmation: {
        id: "recModule.confirmationDialog.deleteRecConfirmation",
        defaultMessage: "Are you sure you want to delete the selected Rec?",
    },
    deleteMultipleRecsConfirmation: {
        id: "recModule.confirmationDialog.deleteMultipleRecsConfirmation",
        defaultMessage: "Are you sure you want to delete the selected Recs?",
    },
    exportControllerFile: {
        id: "recModule.contextMenu.exportControllerFile",
        defaultMessage: "Export Controller {count, plural, one {File} other {Files}}",
    },
    exportComplete: {
        id: "recModule.exportControllerFile.exportComplete",
        defaultMessage: "Export Complete",
    },
    exportFailed: {
        id: "recModule.exportControllerFile.exportFailed",
        defaultMessage: "Export Failed",
    },
    exportToFile: {
        id: "recModule.exportControllerFile.exportToFile",
        defaultMessage: "Export To File",
    },
    exportValidationWarningTitle: {
        id: "recModule.exportControllerFile.exportValidationWarningTitle",
        defaultMessage:
            "Controller File Merge Validation {count, plural, one {Error} other {Errors}}",
    },
    exportValidationWarningOneRecPerField: {
        id: "recModule.exportControllerFile.exportValidationWarningOneRecPerField",
        defaultMessage: "Only one Rec per Field can be selected",
    },
    exportValidationWarningOneRecType: {
        id: "recModule.exportControllerFile.exportValidationWarningOneRecType",
        defaultMessage:
            "Application and Planting Recs cannot be combined in the same Controller File Merge",
    },
    exportValidationWarningPlantingRecType: {
        id: "recModule.exportControllerFile.exportValidationWarningPlantingRecType",
        defaultMessage:
            "Planting (Equation) and Planting (Manual) Recs cannot be combined in the same Controller File Merge",
    },
    exportValidationWarningFilenameRequired: {
        id: "recModule.exportControllerFile.exportValidationWarningFilenameRequired",
        defaultMessage: "Required value",
    },
    exportValidationWarningFilenameSpecialCharacters: {
        id: "recModule.exportControllerFile.exportValidationWarningFilenameSpecialCharacters",
        defaultMessage: "Cannot contain special characters",
    },
    include: {
        id: "recModule.contextMenu.include",
        defaultMessage: "Include",
    },
    jdOperationsCenterText: {
        id: "recModule.contextMenu.jdOperationsCenterText",
        defaultMessage: "JD Operations Center",
    },
    pricing: {
        id: "recModule.components.recSend.pricing",
        defaultMessage: "Pricing",
    },
    products: {
        id: "recModule.components.recSend.products",
        defaultMessage: "Products",
    },
    productSet: {
        id: "recModule.components.recSend.productSet",
        defaultMessage: "Product Set",
    },
    location: {
        id: "recModule.components.recSend.location",
        defaultMessage: "Location",
    },
    sendRecToText: {
        id: "recModule.contextMenu.sendRecToText",
        defaultMessage: "Send Rec To",
    },
    sendRecsToText: {
        id: "recModule.contextMenu.sendRecsToText",
        defaultMessage: "Send Recs To",
    },
    singleBlendTicket: {
        id: "recModule.components.recSend.singleBlendTicket",
        defaultMessage: "Single Blend Ticket",
    },
    singlePlan: {
        id: "recModule.components.recSend.singlePlan",
        defaultMessage: "Single Plan",
    },
    statusMessagesText: {
        id: "recModule.components.recSend.statusMessagesText",
        defaultMessage: "Status Messages",
    },
    workOrderText: {
        id: "recModule.components.recSend.workOrderText",
        defaultMessage: "Work Order Description",
    },
    instructionsText: {
        id: "recModule.components.recSend.instructionsText",
        defaultMessage: "Work Instructions",
    },
    creatingPrescriptionFile: {
        id: "recModule.components.recSend.creatingPrescriptionFile",
        defaultMessage: "Creating prescription for Rec {recName}",
    },
    couldNotCreatePrescriptionFile: {
        id: "recModule.components.recSend.couldNotCreatePrescriptionFile",
        defaultMessage: "{integerId}Could not create prescription file",
    },
    fieldNotAssociatedWithJdOrganization: {
        id: "recModule.components.recSend.fieldNotAssociatedWithJdOrganization",
        defaultMessage:
            "{integerId}This field is not associated with any JD Organization. Please check your Portal Integration settings.",
    },
    missingConnection: {
        id: "recModule.components.recSend.missingConnection",
        defaultMessage:
            "{integerId}A connection is needed with the JD Ops Center Organization to continue",
    },
    missingPermission: {
        id: "recModule.components.recSend.missingPermission",
        defaultMessage:
            "{integerId}Creating Work Plans requires {permissionName} in the JD Ops Center",
    },
    addedCropToWorkPlan: {
        id: "recModule.components.recSend.addedCropToWorkPlan",
        defaultMessage: "Added Crop {cropName} to Work Plan",
    },
    takingFirstOperator: {
        id: "recModule.components.recSend.takingFirstOperator",
        defaultMessage: "Rec contains more than 1 person, setting {operatorName} as the Operator",
    },
    addedOperatorToWorkPlan: {
        id: "recModule.components.recSend.addedOperatorToWorkPlan",
        defaultMessage: "Added Operator {operatorName} to Work Plan",
    },
    skippingEquipment: {
        id: "recModule.components.recSend.skippingEquipment",
        defaultMessage:
            "A Machine has already been added, so skipped adding {equipmentName} to Work Plan",
    },
    addedEquipmentToWorkPlan: {
        id: "recModule.components.recSend.addedEquipmentToWorkPlan",
        defaultMessage: "Added {equipmentType} {equipmentName} to Work Plan",
    },
    createdAndAddedOperatorToWorkPlan: {
        id: "recModule.components.recSend.createdAndAddedOperatorToWorkPlan",
        defaultMessage:
            "Created Operator {operatorName} in the JD Ops Center and added to Work Plan",
    },
    createdClientInJdOpsCenter: {
        id: "recModule.components.recSend.createdClientInJdOpsCenter",
        defaultMessage: "{integerId}Created Client in JD Ops Center named {clientName}",
    },
    couldNotCreateBoundaryInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateBoundaryInJdOpsCenter",
        defaultMessage: "{integerId}Could not create Boundary in JD Ops Center. {detail}",
    },
    couldNotCreateFieldInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateFieldInJdOpsCenter",
        defaultMessage: "{integerId}Could not create Field in JD Ops Center. {detail}",
    },
    couldNotCreateFileInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateFileInJdOpsCenter",
        defaultMessage: "{integerId}Could not create Prescription File in JD Ops Center. {detail}",
    },
    couldNotUploadFileToJdOpsCenter: {
        id: "recModule.components.recSend.couldNotUploadFileToJdOpsCenter",
        defaultMessage: "{integerId}Could not upload Prescription File to JD Ops Center. {detail}",
    },
    couldNotCreateInputInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateInputInJdOpsCenter",
        defaultMessage:
            "{integerId}Could not create or update {inputType} in JD Ops Center. {detail}",
    },
    workPlanCreationOrUpdateForbidden: {
        id: "recModule.components.recSend.workPlanCreationOrUpdateForbidden",
        defaultMessage:
            "{integerId}Work Plan creation or update is forbidden in JD Ops Center. Details :{detail}",
    },
    couldNotCreateOrUpdateWorkPlan: {
        id: "recModule.components.recSend.couldNotCreateOrUpdateWorkPlan",
        defaultMessage:
            "{integerId}Could not create or update Work Plan in JD Ops Center. {detail}",
    },
    couldNotCreateOrUpdateWorkPlanFinalBatch: {
        id: "recModule.components.recSend.couldNotCreateOrUpdateWorkPlanFinalBatch",
        defaultMessage:
            "Could not create or update Work Plans for {numberFailed} of the selected {totalNumber} Recs",
    },
    couldNotCreateOrUpdateWorkPlanFinalSingle: {
        id: "recModule.components.recSend.couldNotCreateOrUpdateWorkPlanFinalSingle",
        defaultMessage: "Could not create or update Work Plan in JD Ops Center.",
    },
    couldNotCreateClientInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateClientInJdOpsCenter",
        defaultMessage: "{integerId}Could not create Client in JD Ops Center named {clientName}",
    },
    couldNotUnarchiveClientInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotUnarchiveClientInJdOpsCenter",
        defaultMessage:
            "{integerId}This JD Client is archived, and cannot be unarchived automatically. Please unarchive Client manually in JD Ops Center.",
    },
    fieldOverlapsWithExistingBoundary: {
        id: "recModule.components.recSend.fieldOverlapsWithExistingBoundary",
        defaultMessage: "{integerId}Field overlaps with existing boundary in the JD Ops Center",
    },
    fieldBoundaryChangeOccurred: {
        id: "recModule.components.recSend.fieldBoundaryChangeOccurred",
        defaultMessage: "{integerId}Field boundary does not match boundary in JD Ops Center",
    },
    recAndFieldBoundaryMismatch: {
        id: "recModule.components.recSend.recAndFieldBoundaryMismatch",
        defaultMessage: "{integerId}Rec does not match boundary in JD Ops Center",
    },
    boundaryWithSameNameAlreadyExists: {
        id: "recModule.components.recSend.boundaryWithSameNameAlreadyExists",
        defaultMessage:
            "{integerId}Field boundary does not match Field with same name in JD Ops Center",
    },
    createdFieldInJdOpsCenter: {
        id: "recModule.components.recSend.createdFieldInJdOpsCenter",
        defaultMessage:
            "{integerId}Created Field in JD Ops Center named {fieldName} on Farm {farmName}",
    },
    unArchivedFarmInJdOpsCenter: {
        id: "recModule.components.recSend.unArchivedFarmInJdOpsCenter",
        defaultMessage: "{integerId}Unarchived Farm in JD Ops Center named {farmName}",
    },
    unArchivedFieldInJdOpsCenter: {
        id: "recModule.components.recSend.unArchivedFieldInJdOpsCenter",
        defaultMessage:
            "{integerId}Unarchived Field in JD Ops Center named {fieldName} on Farm {farmName}",
    },
    unArchivedBoundaryInJdOpsCenter: {
        id: "recModule.components.recSend.unArchivedBoundaryInJdOpsCenter",
        defaultMessage: "Unarchived Boundary for this Field in JD Ops Center",
    },
    madeBoundaryActiveInJdOpsCenter: {
        id: "recModule.components.recSend.madeBoundaryActiveInJdOpsCenter",
        defaultMessage: "Made Boundary for this Field active in JD Ops Center",
    },
    retrievedFieldFromJdOpsCenter: {
        id: "recModule.components.recSend.retrievedFieldFromJdOpsCenter",
        defaultMessage: "{integerId}Found matching Field > {fieldName} in JD Ops Center",
    },
    createdProductInJdOpsCenter: {
        id: "recModule.components.recSend.createdProductInJdOpsCenter",
        defaultMessage: "Created {productType} > {productName} in JD Ops Center",
    },
    retrievedProductFromJdOpsCenter: {
        id: "recModule.components.recSend.retrievedProductFromJdOpsCenter",
        defaultMessage: "Found matching Product {productType} > {productName} in JD Ops Center",
    },
    sentWorkPlanToJdOpsCenter: {
        id: "recModule.components.recSend.sentWorkPlanToJdOpsCenter",
        defaultMessage:
            "{integerId}Created Work Plan in JD Ops Center containing {numberOfInputs} {prod}",
    },
    createdOrUpdatedWorkPlanFinalBatch: {
        id: "recModule.components.recSend.createdOrUpdatedWorkPlanFinalBatch",
        defaultMessage:
            "\nCreated or updated Work Plans for {numberSucceeded} of the selected {totalNumber} Recs",
    },
    updatedWorkPlanInJdOpsCenter: {
        id: "recModule.components.recSend.updatedWorkPlanInJdOpsCenter",
        defaultMessage:
            "{integerId}Updated Work Plan in JD Ops Center containing {numberOfInputs} {prod}",
    },
    exportValidationWarningFalconIdSpecialCharacters: {
        id: "recModule.exportControllerFile.exportValidationWarningFalconIdSpecialCharacters",
        defaultMessage: "Cannot contain letters or special characters",
    },
    exportValidationWarningFalconIdLength: {
        id: "recModule.exportControllerFile.exportValidationWarningFalconIdLength",
        defaultMessage: "Must be 6 characters in length",
    },
    couldNotCreateWorkPlanInJdOpsCenter: {
        id: "recModule.components.recSend.couldNotCreateWorkPlanInJdOpsCenter",
        defaultMessage: "Could not create Work Plan in the JD Ops Center",
    },
    couldNot_InJdOpsCenter: {
        id: "recModule.components.recSend.couldNot_InJdOpsCenter",
        defaultMessage: "Could not {couldNotOperation} in the JD Ops Center",
    },
    batchMessageProcessingRec: {
        id: "recModule.components.recSend.batchMessageProcessingRec",
        defaultMessage:
            "Processing Rec {integerId}: {customerName}{farmName} - {fieldName} - {recName}",
    },
    viewEditDetails: {
        id: "recModule.contextMenu.viewEditDetails",
        defaultMessage: "View / Edit Details",
    },
});
